export default __webpack_public_path__ + "static/media/biryani.806dcb9d.jpg";